require('../../../assets/scripts/jhire/directives/requisitions/jv.ChooseAddReqsFormDirective.js');
require('../../../assets/scripts/common/jv.ModalWrapper.js');
require('../../../assets/scripts/common/jv.MouseoverTooltip.js');
require('../../../assets/scripts/jhire/controllers/requisitions/jv.ReqsIndexCtrl.js');
require('../../../assets/scripts/jhire/modules/jv.Reqs.List.app.js');
require('../../../assets/lib/js/angularmodule/JV.Core.Directives.js');
require('../../../assets/lib/jquery/jquery.placeholder.js');
require('../../../assets/lib/select2/select2-3.4.5/select2.min.js');
require('../../../assets/scripts/jhire/services/jv.Reqs.js');
require('../../../assets/scripts/common/jv.NumberFormat.mask.directive.js');